import { render, staticRenderFns } from "./InternetLiveBoxBlock.vue?vue&type=template&id=b0b4aa42"
import script from "./InternetLiveBoxBlock.vue?vue&type=script&lang=ts"
export * from "./InternetLiveBoxBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports